/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Login from "../../Pages/Login/Login";
import Register from "../../Pages/Register/Register";
import ForgotPassword from "../../Pages/Forgot-Password/ForgotPassword";
import { useCart } from "../../CartContext";
import { PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
// import './Header.css'

export default function Header() {
  const Token = localStorage.getItem("token");
  // const [Token, setToken] = useState(localStorage.getItem("token"));

  const { cartItems, updateCart } = useCart();

  useEffect(() => {
    updateCart(localStorage.getItem("count"));
  }, []);

  const [checkpath, setCheckPath] = useState(false);
  const [currentpath, setcurrentpath] = useState(false);

  const currentUrl = window.location.href;

  useEffect(() => {
    const shouldRenderHeader = currentUrl.includes("create-custom-print");
    setCheckPath(shouldRenderHeader);
    setcurrentpath(shouldRenderHeader);
  }, [currentpath, currentUrl]);

  const toggleClassOnDiv = () => {
    const targetDiv = document.querySelector("#targetDiv");
    const targetDiv2 = document.querySelector("#targetDiv2");
    if (targetDiv) {
      targetDiv.classList.toggle("opened");
    }
    if (targetDiv2) {
      targetDiv2.classList.toggle("apply");
    }
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const submenuStyle = {
    display: isDropdownOpen ? "block" : "none",
    // transition: "display 0.3s ease-in-out", // Adjust the duration as needed
  };

  const [LoginModalOpen, setLoginModalOpen] = useState(false);

  const [hoveredLink, setHoveredLink] = useState(null);

  // useEffect(()=>{
  //   const Token = localStorage.getItem("token");
  // },[LoginModalOpen])

  // const [LoginModalClose, setLoginModalClose] = useState(false);

  // const handleModalClose = (data) => {
  //   console.log(data)
  //   setLoginModalClose(data);
  // };
  // useEffect(()=>{
  //   // const Token = localStorage.getItem("token");
  //   setToken(localStorage.getItem("token"))
  //   console.log('first' , localStorage.getItem("token"))
  // },[LoginModalClose])

  const [ProductList, setProductList] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    GetProductsList();
  }, []);

  const GetProductsList = () => {
    // setLoading(true);
    PostService(API_URL?.GET_PRUDUCTS_LIST, {}).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setProductList(res?.data?.data);
      }
      // setLoading(false);
    });
  };

  const [imageloading, setimageloading] = useState(false);

  const handleImageLoad = () => {
    setimageloading(false);
  };

  return (
    <>
      {/* {!checkpath && ( */}
      {
        <div>
          {/* -----------========This div for Mobile view Header----------==== */}
          <div>
            {/* tp-offcanvus-area-start */}
            <div className="tpoffcanvas-area">
              <div className="tpoffcanvas" id="targetDiv">
                <div className="tpoffcanvas__close-btn">
                  <button className="close-btn" onClick={toggleClassOnDiv}>
                    <i className="fal fa-times" />
                  </button>
                </div>
                <div className="tpoffcanvas__logo">
                  <Link to={"home"} onClick={toggleClassOnDiv}>
                    <img src="assets/img/logo/white-logo.png" alt="" />
                  </Link>
                </div>
                
                <div className="tp-main-menu-mobile d-xl-none">
                  <nav className="tp-main-menu-content">
                    <ul>
                      {/* <li className="has-dropdown">
                        <a href="/our-products">
                          Canvas Options
                          <button className="dropdown-toggle-btn">
                            <i className="fal fa-angle-right" />
                          </button>
                        </a>
                      </li> */}
                      {/* <li className="has-dropdown">
                        <a href="/prices">
                          Prices
                          <button className="dropdown-toggle-btn">
                            <i className="fal fa-angle-right" />
                          </button>
                        </a>
                      </li> */}

                      {/* <li
                        className={`has-dropdown ${
                          isDropdownOpen ? "dropdown-opened" : ""
                        }`}
                      >
                        <Link
                          onClick={toggleDropdown}
                          className={isDropdownOpen ? "expanded" : ""}
                        >
                          Products
                          <button
                            className={`dropdown-toggle-btn ${
                              isDropdownOpen ? "dropdown-opened" : ""
                            }`}
                          >
                            <i
                              className={`fal ${
                                isDropdownOpen
                                  ? "fa-angle-down"
                                  : "fa-angle-right"
                              }`}
                            />
                          </button>
                        </Link>
                        <ul
                          className="submenu tp-submenu add-sunmenu"
                          style={submenuStyle}
                        >
                          <li>
                            <div className="row">
                              <div className="col-xl-4 col-lg-4">
                                <a href="Canvas Options - Gallery Wraps.html">
                                  <h6>Canvas Prints</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                                <a href="/canvas-options-story-canvas">
                                  <h6>Framed Prints</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                                <a href="CanvasOptions-Split Canvases.html">
                                  <h6>Gallery Walls</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                                <a href="Canvas Options-Retouching.html">
                                  <h6>Triptych</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                              </div>
                              <div className="col-xl-4 col-lg-4">
                                <a href="Canvas Options - Gallery Wraps grey.html">
                                  <h6>Plexi Prints</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                                <a href="CanvasOptions-Split Canvases.html.html">
                                  <h6>Prints on Wood</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                                <a href="/canvas-options-gallery-walls">
                                  <h6>Art Tray</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                                <a href="/canvas-options-story-canvas">
                                  <h6>Canvas Rolled in a Tube</h6>
                                  <p>
                                    Upload photos, choose a size, and we’ll ship
                                    your beautiful canvas prints to your door.
                                  </p>
                                </a>
                              </div>
                              <div
                                className="col-xl-4 col-lg-4"
                                style={{ alignSelf: "center" }}
                              >
                                <img src="assets/img/breadcrumb/asdf.png" alt="" />
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li> */}
                      {/* <li className="has-dropdown">
                        <a href="#/about">
                          About Us{" "}
                          <button className="dropdown-toggle-btn">
                            <i className="fal fa-angle-right" />
                          </button>
                        </a>
                      </li> */}
                      <li>
                        <Link to={"/create-custom-print"}>
                          Create Your Print
                        </Link>
                      </li>
                      {!Token && (
                        <li onClick={toggleClassOnDiv}>
                          <a
                            style={{ cursor: "pointer", color: "white" }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            onClick={() => setLoginModalOpen(!LoginModalOpen)}
                          >
                            {" "}
                            Login/Sign-up
                          </a>
                        </li>
                      )}

                      {Token && (
                        <>
                          <li onClick={toggleClassOnDiv}>
                            <Link to={"profile-dashboard"}>My Profile</Link>
                          </li>
                          <li onClick={toggleClassOnDiv}>
                            <Link to={"add-to-cart"}>Shopping Cart</Link>
                          </li>
                        </>
                      )}
                      <li onClick={toggleClassOnDiv}>
                        <Link to={"/about"}>About Us</Link>
                      </li>
                      <li onClick={toggleClassOnDiv}>
                        <Link to={"/contact"}>Contact Us</Link>
                      </li>
                      <li onClick={toggleClassOnDiv}>
                        <Link to={"/questions"}>Questions</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div className="tpoffcanvas__contact-info">
                  <div className="tpoffcanvas__contact-title">
                    <h5>Contact us</h5>
                  </div>
                  <ul>
                    <li>
                      <i className="fa-light fa-location-dot" />
                      <a
                        href="https://www.google.com/maps/@23.8223586,90.3661283,15z"
                        target="_blank"
                      >
                        5767 Major Blvd,Orlando Fl. 32819
                      </a>
                    </li>
                    <li>
                      <i className="fas fa-envelope" />
                      <a href="https://template.wphix.com/cdn-cgi/l/email-protection#9be8f4f7fae9fefffcfedbfcf6faf2f7b5f8f4f6">
                        <span
                          className="__cf_email__"
                          data-cfemail="780c101d151d080d0a1d381f15191114561b1715"
                        >
                          info@Printlific.com
                        </span>
                      </a>
                    </li>
                    <li>
                      <i className="fal fa-phone-alt" />
                      <a href="tel:+48555223224">+1 (917) 386-4948</a>
                    </li>
                  </ul>
                </div>
                <div className="tpoffcanvas__input">
                  <div className="tpoffcanvas__input-title">
                    <h4>Get UPdate</h4>
                  </div>
                  {/* <form action="#"> */}
                  <div className="p-relative">
                    <input type="text" placeholder="Enter mail" />
                    <button>
                      <i className="fas fa-paper-plane" />
                    </button>
                  </div>
                  {/* </form> */}
                </div>
                <div className="tpoffcanvas__social">
                  <div className="social-icon">
                    <a href="#">
                      <i className="fa-brands fa-apple" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-skype" />
                    </a>
                    <a href="#">
                      <i className="fa-brands fa-twitter" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="body-overlay"
              id="targetDiv2"
              onClick={toggleClassOnDiv}
            />
            {/* tp-offcanvus-area-end */}
          </div>
          {/* ------------------------------ Mobile view Header Ends---------------- */}

          <header className="tp-header-height">
            {/* tp-header-top-area-start */}
            {!checkpath && (
              <div className="tp-header-top-2__area theme-bg tp-header-2__plr">
                <div className="tp-header-top-2__space">
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-xxl-8 col-xl-6 col-lg-8 col-md-12 col-sm-12">
                        <div className="tp-header-top-2__left-box text-center text-md-start">
                          {/* <Link to={"giftCards"}>Gift Cards</Link> */}
                          <Link to={"ourArtCanvas"}>Our Art Canvas</Link>
                          <Link to={"affiliateProgram"}>Influencer Program</Link>
                          {/* <Link to={"questions"}>Questions</Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* tp-header-top-area-end */}

            {/* tp-header-area-start */}
            <div
              id="header-sticky"
              className="tp-header-2__area tp-header-2__space tp-header-2__plr"
            >
              <div className="container">
                <div className="row align-items-center position">
                  <div className="col-xxl-2 col-xl-2 col-lg-6 col-md-4 col-6">
                    <div className="tp-header-2__logo">
                      <Link to={"home"}>
                        {" "}
                        <img src="assets/img/logo/logo.png" alt="" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 d-none d-xl-block header-add p-0">
                    <div className="tp-header-2__main-menu tp-header__main-menu">
                      <nav className="tp-main-menu-content">
                        <ul>
                          {/* <li className="has-dropdown">
                            <Link to={"canvasOptions"}>Canvas Options</Link>
                          </li> */}

                          {/* <li className="has-dropdown">
                        <Link to={"prices"}>Prices</Link>
                      </li> */}

                          <li className="has-dropdown">
                            <a
                              href="#"
                              onMouseEnter={() =>
                                setHoveredLink("assets/img/blog/blog1-1.png")
                              }
                            >
                              Products
                            </a>
                            &nbsp;
                            <i className="fa fa-angle-down" />
                            <ul className="submenu tp-submenu add-sunmenu">
                              <li>
                                <div className="row">
                                  <div className="col-xl-8 col-lg-8">
                                    <div className="row">
                                      {ProductList &&
                                        ProductList.map((data) => (
                                          <div
                                            className="col-xl-6 col-lg-6"
                                            key={data.id}
                                          >
                                            <Link
                                              to={`/our-products/${data?.id}`}
                                              onMouseEnter={() => {
                                                setHoveredLink(
                                                  data?.product_image
                                                );
                                                setimageloading(true);
                                              }}
                                            >
                                              <h6>{data?.product_title}</h6>
                                              <p>
                                                {data?.description.split(" ")
                                                  .length > 12
                                                  ? data?.description
                                                      .split(" ")
                                                      .slice(0, 12)
                                                      .join(" ") +
                                                    (data?.description.split(
                                                      " "
                                                    ).length > 12
                                                      ? "..."
                                                      : "")
                                                  : data?.description}
                                              </p>
                                            </Link>
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                  <div
                                    // className="col-xl-4 col-lg-4 d-flex justify-content-center align-item-baseline"
                                    className="col-xl-4 col-lg-4 text-center"
                                    // style={{ alignSelf: "center" }}
                                  >
                                    {imageloading && (
                                      <div className="mt-100 align-items-center d-flex justify-content-center">
                                        <i
                                          className="fa fa-spinner fa-pulse fa-2x fa-fw"
                                          style={{ animationDuration: "1.5s" }}
                                        ></i>
                                      </div>
                                    )}
                                    <img
                                      src={
                                        hoveredLink ||
                                        ProductList[0]?.product_image
                                      }
                                      alt="..."
                                      onError={(e) => {
                                        setimageloading(false);
                                        e.target.src =
                                          "assets/img/blog/bop-1.png";
                                      }}
                                      onLoad={handleImageLoad}
                                      className={
                                        imageloading ? "d-none" : "d-block"
                                      }
                                    />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </li>

                          <li className="has-dropdown">
                            {/* <NavLink to={"about"} activeClassName="active"> */}
                            <NavLink to={"about"}>About Us</NavLink>
                          </li>
                          <li>
                            {/* <NavLink to={"contact"} activeClassName="active"> */}
                            <NavLink to={"contact"}>Contact Us</NavLink>
                          </li>
                          <li>
                            <NavLink to={"questions"}>Questions</NavLink>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-8 col-6">
                    <div className="tp-header-2__right-box text-end">
                      <ul>
                        <li>
                          {/* <div className="tp-header-2__icon-box d-none d-md-block"> */}
                          <div className=" d-none d-md-block">
                            {/* <a href="#">
                              <span className="heart p-relative">
                                <i className="fa-regular fa-search" /> 
                              </span>
                            </a> */}
                            {!Token && (
                              <a style={{ cursor: "pointer" }}>
                                <span
                                  className="heart p-relative middle-icon"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                  onClick={() =>
                                    setLoginModalOpen(!LoginModalOpen)
                                  }
                                >
                                  <i className="fa-regular fa-user fa-lg" />
                                </span>
                              </a>
                            )}
                            {Token && (
                              <>
                                <span
                                  className="fw-bold"
                                  style={{ fontSize: "14px", color: "#1f4ce0" }}
                                >
                                  Hi,{localStorage.getItem("user")}
                                </span>
                                <Link to={"profile-dashboard"} className="mx-2">
                                  {" "}
                                  <span className="heart p-relative middle-icon p-0 ps-1">
                                    <i className="fa-regular fa-user fa-lg" />
                                  </span>
                                </Link>
                              </>
                            )}
                            {/* Button trigger modal */}
                            {/* <Link to={"create-print"}> */}
                            {Token && (
                              <Link to={"add-to-cart"} className="mx-2">
                                <span className="heart p-relative">
                                  <i className="fa-regular fa-cart-shopping fa-lg">
                                    {" "}
                                    <sup
                                      className="badge rounded-pill bg-danger translate-middle position-absolute px-2 py-1"
                                      style={{ fontSize: "10px" }}
                                    >
                                      {cartItems > 0 ? cartItems : ""}
                                    </sup>{" "}
                                  </i>
                                  {/* <b class="tp-header__icon-text"></b> */}
                                </span>
                              </Link>
                            )}
                          </div>
                        </li>
                        <li>
                          <div className="tp-header__chat-box d-none d-xxl-block d-xl-block">
                            <Link
                              className="tp-btn-lg large head"
                              // to={"create_your_print"}
                              to={"create-custom-print"}
                            >
                              Create Your PRINT
                            </Link>
                          </div>
                        </li>
                        <li className="d-xl-none" id="toggleButton">
                          <div className="tp-header-2__bar">
                            <button
                              className="tp-menu-bar"
                              onClick={toggleClassOnDiv}
                            >
                              <i className="fa-solid fa-bars" />
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* tp-header-area-end */}
          </header>

          <div>
            {/* Modal */}

            <Login reset={LoginModalOpen} />

            <ForgotPassword />
          </div>
        </div>
      }
    </>
  );
}
